(function ($) {
    'use strict';

    $.sticky = new Object({
        init: function () {
            this.getElement();
        },

        getElement: function () {
            $('.sticky[data-sticky]').each(function () {
                var _elem = $(this).data('sticky'),
                    _elem = $(_elem);

                $(this).css('top', _elem.height());
            });
        },
    });
})(jQuery);
